export function guestsAdviceRoomsDocumentsApi(path: string) {
  return {
    path,
  };
}
